"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TWAPTradeUtils = void 0;
// twap默认十分钟投一次
const react_1 = require("react");
const TradeAPILib_1 = require("TradeAPILib");
const decimal_js_1 = __importDefault(require("decimal.js"));
const TradeErrorConstants_1 = require("./TradeErrorConstants");
const GridTypes_1 = require("../Trading/GridTrading/GridTypes");
const trade_utils_lib_1 = require("trade_utils_lib");
exports.TWAPTradeUtils = {
    getTradeTimes(period) {
        const value = new trade_utils_lib_1.SafeDecimal(period).div(new trade_utils_lib_1.SafeDecimal(GridTypes_1.TWAP_TRADE_TIME_INTERVAL)).add(1);
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(value, 10).toNumber();
    },
    getInvestPerTime(period, invest, precision) {
        const tradeTime = this.getTradeTimes(period);
        if (!tradeTime) {
            return 0;
        }
        return trade_utils_lib_1.NumberCommonUtils.formatterDecimal(new trade_utils_lib_1.SafeDecimal(invest).div(new trade_utils_lib_1.SafeDecimal(tradeTime)), precision).toNumber();
    },
    useInvestPerTime(period, invest, precision) {
        const [result, setResult] = (0, react_1.useState)('0');
        (0, react_1.useEffect)(() => {
            const investNum = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(invest, precision).toNumber();
            if (!investNum) {
                setResult('0');
            }
            const value = this.getInvestPerTime(period, investNum, precision);
            setResult(trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(value, precision));
        }, [period, invest, precision]);
        return result;
    },
    checkLocalError(tradeTimes, totalInvest, minValue, balance, precision, unit, side, $st) {
        const investPerTime = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(new trade_utils_lib_1.SafeDecimal(totalInvest).div(new trade_utils_lib_1.SafeDecimal(tradeTimes)), precision).toNumber();
        const min = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(minValue, precision, decimal_js_1.default.ROUND_CEIL).toNumber();
        if (!totalInvest) {
            return TradeErrorConstants_1.TradeErrorConstants.inputInvest($st);
        }
        if (investPerTime < min) {
            if (side === TradeAPILib_1.ExchangeOrderSide.buy) {
                const total = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(new trade_utils_lib_1.SafeDecimal(min).mul(new trade_utils_lib_1.SafeDecimal(tradeTimes)), precision, decimal_js_1.default.ROUND_CEIL);
                return $st("trading_twap_buy_quantity_low", { min: min, total: total, quote: unit });
            }
            else {
                return $st("trading_twap_sell_quantity_low", { min: min, base: unit });
            }
        }
        if (totalInvest > balance) {
            return TradeErrorConstants_1.TradeErrorConstants.balanceNotEnough($st);
        }
        return undefined;
    },
    useError(period, totalInvest, minValue, balance, precision, unit, side, $st) {
        const [error, setError] = (0, react_1.useState)(undefined);
        (0, react_1.useEffect)(() => {
            const totalInvestNum = trade_utils_lib_1.NumberCommonUtils.formatterDecimal(totalInvest, precision).toNumber();
            if (!totalInvestNum) {
                setError('');
                return;
            }
            const tradeTimes = this.getTradeTimes(period);
            const error = this.checkLocalError(tradeTimes, totalInvestNum, minValue, balance, precision, unit, side, $st);
            setError(error);
        }, [period, totalInvest, minValue, balance, precision, unit, side]);
        return error;
    }
};
